<template>
  <div>
    <div v-for="variant in answer.variants" :key="variant.id" class="row">
      <div
        class="col-xl-8 col-lg-8 col-md-7 col-sm-6 col-12"
        :class="{ failed: variant.failed }"
      >
        {{ variant.text }}
      </div>
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-6 text-right">
        <app-button-toggle
          :questionId="questionId"
          :expected-answer="variant.expectedAnswer"
          v-model="variant.expectedAnswer"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import constants from "@/entities/constants";
import { SingleItemAnswer } from "@/entities/questionaire/answers/SingleItemAnswer";
import AppButtonToggle from "@/components/expert/AppButtonToggle.vue";

@Component({
  name: constants.answerTypes.SingleItemAnswer.componentName,
  components: {
    AppButtonToggle
  }
})
export default class AppSingleItemAnswer extends Vue {
  @Prop()
  questionId!: number;

  @Prop()
  answer!: SingleItemAnswer;
}
</script>

<style scoped lang="scss">
.failed {
  color: red;
}
</style>
